import ErrorComponent from "@/components/atoms/ErrorComponent";
import CompanyCourseStatusHeader from "@/components/molecules/card-headers/companies/CompanyCourseStatusHeader";
import CompanyCourseStatusDetailsCard from "@/components/molecules/cards/companies/CompanyCourseStatusDetailsCard";
import { UUID_REGEX } from "@/constants/regexs";
import { pluralize } from "@/helpers/utils";
import CompanyCourseStatus from "@/interfaces/CompanyCourseStatus";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, useState } from "react";
import { Card, Col, Nav, Row, Tab } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SimpleBar from "simplebar-react";

const CompanyCourseStatusView: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [companyCourseStatus, setCompanyCourseStatus] =
    useState<CompanyCourseStatus>();
  const [totals, setTotals] = useState({
    courses: 0,
  });

  const onGetTotal = (key: string, total: number) => {
    setTotals((prev) => ({ ...prev, [key]: total }));
  };

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="formalys-page formalys-detail-page">
      {companyCourseStatus && <CompanyCourseStatusHeader id={id} />}
      <Row className="g-3">
        <Col xxl={4} xl={5}>
          <CompanyCourseStatusDetailsCard
            id={id}
            card
            callBack={setCompanyCourseStatus}
          />
        </Col>
        {companyCourseStatus && (
          <Col xxl={8} xl={7}>
            <Card>
              <Tab.Container defaultActiveKey="courses">
                <SimpleBar>
                  <Card.Header className="p-0 border-bottom">
                    <Nav className="nav-tabs border-0 flex-nowrap tab-contact-details">
                      <Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="courses"
                            className="d-flex align-items-center py-3 px-x1 mb-0"
                          >
                            <FontAwesomeIcon
                              icon={faUser}
                              className="text-600 tab-icon"
                            />
                            <h6 className="text-600 mb-0 ms-1">
                              {pluralize("Formation", totals.courses)}
                              &nbsp;(
                              {totals.courses})
                            </h6>
                          </Nav.Link>
                        </Nav.Item>
                      </Nav.Item>
                    </Nav>
                  </Card.Header>
                </SimpleBar>
                <Card.Body className="bg-light">
                  <Tab.Content>
                    <Tab.Pane eventKey="courses"></Tab.Pane>
                  </Tab.Content>
                </Card.Body>
              </Tab.Container>
            </Card>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default CompanyCourseStatusView;
